import type { UpdateStatus } from "aint-types";

export const STATUS_MAPPING = {
  ended: "mood-smile.svg",
  completed: "mood-smile.svg",
  overdue: "mood-sad.svg",
  pending: "mood-neutral.svg",
} as const satisfies Record<UpdateStatus, string>;

export function getStatusIcon<T extends UpdateStatus>(
  status: T
): (typeof STATUS_MAPPING)[T] {
  return STATUS_MAPPING[status];
}
